"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
const globals_1 = require("models/globals");
class Participe extends webix_jet_1.JetView {
    config() {
        const tree = {
            view: "align", align: "center",
            body: {
                id: "form1",
                view: "form", scroll: true,
                width: 440,
                margin: 0,
                border: 0,
                elements: [
                    {
                        template: "<h2 class='center'>Club Montagne Colomiers</br>Inscriptions</br></h2>" +
                            "<h3 style='color:darkblue' class='center'>Marche Nordique</h3>",
                        id: "titre1",
                        height: 115,
                        border: 5
                    },
                    // {template: "<h3 class='center'>Marche Nordique</h3>", height: 45, border: 0},
                    {
                        view: "list",
                        id: "list1",
                        // css : "nth-child(2n){background-color:#DDDDDD;}",
                        template: "<span style='color:darkblue'><strong>#jour#</strong></span>" +
                            " &nbsp #date# - #lieu# " +
                            "<div style='padding-left:58px'> Animé par : <strong>#animateur#</strong>" +
                            " vitesse : <strong>#vitesse#</strong> </div>",
                        type: {
                            height: 50
                        },
                        select: true,
                        autowidth: true,
                        autoheight: true,
                    },
                    // 		{
                    // 			cols: [
                    // 				{template: "<div style='font-weight: bold'>Nom et prénom", height: 24, width: 200},
                    // 				{template: "<div style='font-weight: bold'>Je participe", width: 75},
                    // 				{view : "template", template: "", id: "compteur",
                    // 						css: "<div style='font-weight: bold'><div style='padding-left:30px'>"}
                    // 			]
                    // 		},
                    // 		{
                    // 			cols: [
                    // 				{view: "text", id:"champNom", name: "nom", height: 24, width: 200
                    // 					,on : {onChange: function(newValue) { lv2.clean(newValue,this) }}},
                    // 				{template: "<div style='padding-left:28px'>", borderless: true},
                    // 				{view: "checkbox", id : "champParticipe", value: 0, width: 50
                    // 					, uncheckValue: "Non", checkValue: "Oui"},
                    // 				{view: "button", id : "boutonValider", value: "Valider", width: 100}
                    // 			]
                    // 		}, {
                    // 			view: "datatable",
                    // 			id: "list2",
                    // 			columns: [
                    // 				{ id: "nom", editor:"text", header: "Nom", width: 200},
                    // 				{ id: "idSortie", hidden : true},
                    // 				{
                    // 					id: "participe", header: "Inscrit", template: "{common.checkbox()}"
                    // 					, uncheckValue: "Non", checkValue: "Oui", width: 80
                    // 				}
                    // 			],
                    // 			type: {
                    // 				height: 30
                    // 			},
                    // 			select: true,
                    // 			editable:true,
                    // 			autowidth: true,
                    // 			autoheight: true
                    // 		}, {
                    // 			template : "<h6 class='center'>Copyright Luc Van Vlasselaer : info@alnitac.com</h6>"
                    // 		}
                ]
            }
        };
        return tree;
    }
    // majCompteur() {
    // 	let me = this;
    // 	me.count = 0;
    // 	// me.listeParticipants.data.each(function(obj){
    // 	// 	if (obj.participe == "Oui") me.count++;
    // 	// });
    // 	let compteurField = $$("compteur") as webix.ui.template;
    // 	let acss = "<div style='font-weight: bold'><div style='padding-left:30px'>";
    // 	let vv = acss + me.count
    // 	if (me.maxParticipants > 0) {
    // 		vv = vv + " / " + me.maxParticipants;
    // 	}
    // 	compteurField.setHTML(vv);
    // 	if (me.maxParticipants > 0 && me.count >  this.maxParticipants) {
    // 		webix.alert("Le nombre maximal de participants est dépassé !");
    // 	}
    // }
    // choixSortie(id) {
    // 	let index = this.listeSorties.getIndexById(id);
    // 	let sortie = this.listeSorties.getItem(id);
    //
    // 	this.listeParticipants.editCancel();
    // 	this.listeParticipants.clearAll();
    // 	this.listeParticipants.load(phpPath + "listeSorties.php?option=listeparticipants&dd=" + this.dataDir + "&idSortie=" + sortie.unid);
    // 	this.idSortie = sortie.unid;
    // }
    init() {
        let me = this;
        let idSortie = 0;
        // let t1 = $$("titre1") as webix.ui.template;
        // let s1 = "Marche Nordique";
        // let s2 = "Club Montagne Colomiers";
        //
        // this.listeSorties = $$("list1") as webix.ui.list;
        // this.listeParticipants = $$("list2") as webix.ui.datatable;
        // this.listeParticipants.attachEvent("onBeforeEditStop", function (state, editor, ignore) {
        // 	state.value = lv2.verifTexte(state.value);
        // })
        // this.listeParticipants.attachEvent("onAfterEditStop", function (state, editor, ignore) {
        // 	me.saveInscrits(me.idSortie);
        // })
        // this.listeParticipants.attachEvent("onCheck", function (row, column, state) {
        // 	me.saveInscrits(me.idSortie);
        // });
        // // this.listeSorties.attachEvent("onItemClick", function (id) {
        // // 	me.choixSortie(id)
        // // });
        // this.listeSorties.attachEvent("onAfterSelect", function (id) {
        // 	me.choixSortie(id)
        // });
        //
        // this.listeSorties.attachEvent("onAfterLoad", function (id) {
        // 		if (me.listeSorties.getFirstId() > 0) {
        // 			// @ts-ignore
        // 			me.listeSorties.select(me.listeSorties.getFirstId(), true);
        // 			me.choixSortie(me.listeSorties.getFirstId());
        // 		} else {
        // 			webix.alert("Aucune sortie n'est planifiée !");
        // 		}
        // 	}
        // )
        // this.listeParticipants.attachEvent("onAfterLoad", function (id) {
        // 		me.majCompteur();
        // 	}
        // )
        // let boutonValider = $$("boutonValider") as webix.ui.button;
        // let champNom = $$("champNom") as webix.ui.text;
        // let champParticipe = $$("champParticipe") as webix.ui.text;
        // boutonValider.attachEvent("onItemClick", function () {
        // 	let nom = champNom.getValue();
        // 	let participe = champParticipe.getValue();
        // 	if (nom.length < 4) {
        // 		webix.alert("Le champ nom contient moins de 4 lettres");
        // 	} else {
        // 		// TODO vérifier si le nom n'est pas déjà dans la liste
        // 		// Ajout du nom dans la liste
        // 		let np = {"nom": nom, "idSortie": me.idSortie, "participe": participe}
        // 		me.listeParticipants.add(np, 0);
        // 		champNom.setValue("");
        // 		champParticipe.setValue("Oui");
        // 		// boutonValider.disable();
        // 	}
        // 	me.saveInscrits(me.idSortie);
        // })
        // // boutonValider.disable();
        // // champNom.attachEvent("onKeyPress", function (code, e) {
        // // 	// var value = this.getValue().toLowerCase();
        // // 	if (this.getValue().length > 2) {
        // // 		boutonValider.enable();
        // // 	} else {
        // // 		boutonValider.disable();
        // // 	}
        // // })
        // let config = webix.ajax().get(phpPath + "listeSorties.php?option=params&dd=" + this.dataDir);
        // config.then(function(result) {
        // 	me.params = result.json();
        // 	// this.titre
        // 	if (me.params["titre1"]) {
        // 		s1 = me.params["titre1"];
        // 	}
        // 	if (me.params["titre2"]) {
        // 		s2 = me.params["titre2"];
        // 	}
        // 	t1.setHTML("<h2 class='center'>" + s1 + "</br>" + s2 + "</h2>");
        // 	me.maxParticipants = 0;
        // 	if (me.params["maxParticipants"]) {
        // 		me.maxParticipants = me.params["maxParticipants"]
        // 	}
        // });
        let list = this.$$('list1');
        let promise = list.load(globals_1.phpPath + "Inscriptions.php?option=shortList");
        promise.then(function (result) {
            if (result.json().success == false) {
                webix.alert(result.json().message);
                return;
            }
        });
        list.attachEvent("onSubViewCreate", function (view, item) {
            view.parse(item.outlets);
        });
    }
    ready() {
        let list = this.$$("list");
        // list.openAll();
    }
}
exports.default = Participe;
